import { useState } from 'react';
import { useBulkBroadcastActionsPermission } from 'src/components/common/BulkActions/BulkBroadcastActions/useBulkBroadcastActionsPermission';
import { useBulkActionsState } from 'src/components/common/BulkActions/useBulkActionsState';
import { useBulkAddHoldAction } from 'src/components/Listings/InventoryActionDropdown/components/BulkAddHoldAction';
import { useBulkEditBroadcastGlobalSettingsAction } from 'src/components/Listings/InventoryActionDropdown/components/BulkEditBroadcastSettingsAction/useBulkEditBroadcastGlobalSettingsAction';
import { useBulkMergeSelectedListingsAction } from 'src/components/Listings/InventoryActionDropdown/components/BulkMergeSelectedListingsAction';
import { useBulkRemoveHoldAction } from 'src/components/Listings/InventoryActionDropdown/components/BulkRemoveHoldAction';
import { useBulkResetMergedListingsAction } from 'src/components/Listings/InventoryActionDropdown/components/BulkResetMergedListingsAction';
import { useBulkSplitSelectedListingsAction } from 'src/components/Listings/InventoryActionDropdown/components/BulkSplitSelectedListingsAction';
import { useBulkUngroupListings } from 'src/components/Listings/InventoryActionDropdown/components/LaunchUngroupListingsAction';
import { Content } from 'src/contexts/ContentContext';
import { PosDropdown } from 'src/core/POS/PosDropdown';
import { vars } from 'src/core/themes';
import { Button } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ChevronDownIcon, IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

import { useInventoryEventBulkActionsState } from '../../InventoryEventBulkActions/useInventoryEventBulkActionsState';

export const BroadcastActions = () => {
  const { areBulkActionsEnabled } = useBulkActionsState();
  const [isLoading, setIsLoading] = useState(false);
  const { hasBroadcastPermission } = useBulkBroadcastActionsPermission();
  const hasBulkSplitListingsFeature = useUserHasFeature(
    Feature.BulkSplitListings
  );

  const { filterQueryWithEventIds } = useInventoryEventBulkActionsState();

  const bulkAddHold = useBulkAddHoldAction(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    undefined
  );

  const bulkRemoveHold = useBulkRemoveHoldAction(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    undefined
  );

  const bulkUngroupListings = useBulkUngroupListings(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    undefined
  );

  const bulkEditBroadcastSettings = useBulkEditBroadcastGlobalSettingsAction({
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
  });

  const bulkSplitToOriginalAction = useBulkResetMergedListingsAction(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    undefined
  );

  const bulkMergeSelectedListingsAction = useBulkMergeSelectedListingsAction(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    undefined
  );

  const bulkSplitSelectedListingsAction = useBulkSplitSelectedListingsAction(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    undefined
  );

  return (
    <>
      <PosDropdown
        key="events-broadcast-actions-dropdown"
        trigger={
          <Button variant="outline">
            <Content id={ContentId.Broadcast} />
            <ChevronDownIcon
              size={vars.iconSize.xs}
              fill={IconsFill.currentColor}
            />
          </Button>
        }
        align="end"
        triggerProps={{ disabled: isLoading || !areBulkActionsEnabled }}
      >
        {hasBroadcastPermission && bulkEditBroadcastSettings.dropDown}
        {bulkAddHold.dropDown}
        {bulkRemoveHold.dropDown}
        {bulkUngroupListings.dropDown}
        {bulkSplitToOriginalAction.dropDown}
        {bulkMergeSelectedListingsAction.dropDown}
        {hasBulkSplitListingsFeature &&
          bulkSplitSelectedListingsAction.dropDown}
      </PosDropdown>
    </>
  );
};
